"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCanvasMouseLeave = exports.handleCanvasClick = exports.handleCanvasMouseMove = exports.createAndAddFlowerIfInteractive = void 0;
var dom = __importStar(require("./domElements.ts"));
var config = __importStar(require("./config.ts"));
var state = __importStar(require("./state.ts"));
var animationManager_ts_1 = require("./animationManager.ts");
var drawingUtils_ts_1 = require("./drawingUtils.ts");
var mirroringUtils_ts_1 = require("./mirroringUtils.ts");
var colorUtils_ts_1 = require("./colorUtils.ts");
function createAndAddFlowerIfInteractive(cell, idSuffix, isMockFlower, sourceProximityFactor, forceCreation, isUserClick, specialColorOverrides) {
    if (isMockFlower === void 0) { isMockFlower = false; }
    if (forceCreation === void 0) { forceCreation = false; }
    if (isUserClick === void 0) { isUserClick = false; }
    if (performance.now() < state.initialFlowerCreationDelayEndTime) {
        // Check flower creation delay
        return;
    }
    // Only apply post-sweep delay if it's NOT a user click
    if (!isUserClick &&
        performance.now() < state.postSweepFlowerDelayActiveUntil) {
        return;
    }
    if (!cell || !dom.canvas)
        return;
    var flowerGridSnapCellPixelSize = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS * state.calculatedSegmentSize;
    if (flowerGridSnapCellPixelSize <= 0)
        return;
    var cellCenterX_px = cell.x + flowerGridSnapCellPixelSize / 2;
    var cellCenterY_px = cell.y + flowerGridSnapCellPixelSize / 2;
    var gridX = Math.floor(cellCenterX_px / state.calculatedSegmentSize);
    var gridY = Math.floor(cellCenterY_px / state.calculatedSegmentSize);
    var effectTime = performance.now();
    var effectIdBase = "".concat(effectTime, "-").concat(Math.random()
        .toString(36)
        .substring(2, 9));
    var currentPatternDimension;
    var currentMaxFillRatio;
    var currentFlowerProximityInfluence = sourceProximityFactor;
    var finalEffectivePalette = undefined;
    if (isUserClick) {
        finalEffectivePalette = __spreadArray([], config.CLICK_CURSOR_COLORS, true);
        currentPatternDimension = config.PATTERN_DIMENSION;
        currentMaxFillRatio = config.CLICK_MAX_FILLED_CELL_RATIO; // Use new config for clicks
    }
    else if (sourceProximityFactor !== undefined) {
        var basePatternDim = config.PATTERN_DIMENSION;
        var baseFillRatio = config.MAX_FILLED_CELL_RATIO; // Hover uses original fill ratio config
        // Fix issue where mock flowers draw a flower that is one unit bigger than the box size
        if (isMockFlower) {
            basePatternDim -= 1;
        }
        currentPatternDimension = Math.round(config.MIN_PATTERN_DIMENSION_PROXIMITY +
            (basePatternDim +
                config.MAX_PATTERN_DIMENSION_PROXIMITY_BOOST -
                config.MIN_PATTERN_DIMENSION_PROXIMITY) *
                sourceProximityFactor);
        currentPatternDimension = Math.max(config.MIN_PATTERN_DIMENSION_PROXIMITY, Math.min(basePatternDim + config.MAX_PATTERN_DIMENSION_PROXIMITY_BOOST, currentPatternDimension));
        currentMaxFillRatio =
            config.MIN_FILL_RATIO_PROXIMITY +
                (baseFillRatio +
                    config.MAX_FILL_RATIO_PROXIMITY_BOOST -
                    config.MIN_FILL_RATIO_PROXIMITY) *
                    sourceProximityFactor;
        currentMaxFillRatio = Math.max(config.MIN_FILL_RATIO_PROXIMITY, Math.min(baseFillRatio + config.MAX_FILL_RATIO_PROXIMITY_BOOST, currentMaxFillRatio));
    }
    else {
        currentPatternDimension = config.PATTERN_DIMENSION;
        currentMaxFillRatio = config.MAX_FILLED_CELL_RATIO; // Default hover fill ratio
    }
    var chosenPatternStyle = "pixelStandard";
    var patternSegmentsData = undefined;
    var maxRingIdx = Math.max(1, currentPatternDimension - 1);
    var generatedData = (0, drawingUtils_ts_1.generatePatternData)(currentPatternDimension, currentMaxFillRatio, chosenPatternStyle, currentFlowerProximityInfluence, finalEffectivePalette);
    patternSegmentsData = generatedData;
    var effect = {
        id: "flower-".concat(effectIdBase, "-").concat(idSuffix),
        clickGridX: gridX,
        clickGridY: gridY,
        startTime: effectTime,
        maxRingIndex: maxRingIdx,
        patternStyle: chosenPatternStyle,
        patternSegments: patternSegmentsData,
        isMockUserFlower: isMockFlower,
        isUserClickFlower: isUserClick,
        flowerProximityInfluence: currentFlowerProximityInfluence,
        effectivePalette: finalEffectivePalette
    };
    // Apply symmetrical special color overrides if enabled and provided
    if (state.enableSymmetricalSpecialColor &&
        specialColorOverrides &&
        effect.patternSegments) {
        specialColorOverrides.forEach(function (override) {
            if (effect.patternSegments &&
                effect.patternSegments[override.r] &&
                effect.patternSegments[override.r][override.c]) {
                effect.patternSegments[override.r][override.c].color = override.color;
                effect.patternSegments[override.r][override.c].visible = true; // Ensure visibility for special color
            }
        });
    }
    if (forceCreation || isMockFlower || isUserClick) {
        state.activeEffects.push(effect);
    }
    else {
        var recentlyCreatedActiveEffectExists = state.activeEffects.some(function (ae) {
            return ae.clickGridX === effect.clickGridX &&
                ae.clickGridY === effect.clickGridY &&
                Math.abs(ae.startTime - effect.startTime) < 50;
        });
        if (recentlyCreatedActiveEffectExists) {
            return;
        }
        state.activeEffects.push(effect);
    }
}
exports.createAndAddFlowerIfInteractive = createAndAddFlowerIfInteractive;
function handleCanvasMouseMove(event) {
    if (!dom.ctx || !dom.canvas || !state.logicalGridCells)
        return;
    var rect = dom.canvas.getBoundingClientRect();
    var clickCanvasX = (event.clientX - rect.left) * (dom.canvas.width / rect.width);
    var clickCanvasY = (event.clientY - rect.top) * (dom.canvas.height / rect.height);
    var effectiveClickX = clickCanvasX;
    var effectiveClickY = clickCanvasY;
    var minDistanceSq = Infinity;
    if (config.numberOfMockUsers > 0 && state.mockUserCursors.length > 0) {
        state.mockUserCursors.forEach(function (mockCursor) {
            if (mockCursor.currentPixelX > -500) {
                var dx = clickCanvasX -
                    (mockCursor.currentPixelX +
                        (config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS *
                            state.calculatedSegmentSize) /
                            2);
                var dy = clickCanvasY -
                    (mockCursor.currentPixelY +
                        (config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS *
                            state.calculatedSegmentSize) /
                            2);
                minDistanceSq = Math.min(minDistanceSq, dx * dx + dy * dy);
            }
        });
    }
    var minDistance = Math.sqrt(minDistanceSq);
    var calculatedProximityFactor = 0.0;
    if (state.mockUserCursors.length === 0 ||
        config.numberOfMockUsers === 0 ||
        minDistanceSq === Infinity) {
        calculatedProximityFactor = 0.0;
    }
    else if (minDistance <= config.MAIN_CURSOR_PROXIMITY_CLOSE_THRESHOLD_PX) {
        calculatedProximityFactor = 1.0;
    }
    else if (minDistance < config.MAIN_CURSOR_PROXIMITY_FAR_THRESHOLD_PX) {
        calculatedProximityFactor =
            1.0 -
                (minDistance - config.MAIN_CURSOR_PROXIMITY_CLOSE_THRESHOLD_PX) /
                    (config.MAIN_CURSOR_PROXIMITY_FAR_THRESHOLD_PX -
                        config.MAIN_CURSOR_PROXIMITY_CLOSE_THRESHOLD_PX);
        calculatedProximityFactor = Math.max(0, Math.min(1, calculatedProximityFactor));
    }
    else {
        calculatedProximityFactor = 0.0;
    }
    state.setMainCursorProximityFactor(calculatedProximityFactor);
    var flowerGridSnapCellPixelSize = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS * state.calculatedSegmentSize;
    if (flowerGridSnapCellPixelSize <= 0) {
        state.setCurrentHoveredPrimaryCell(null);
        state.setCurrentHoveredMirroredCell(null);
        state.setCurrentHoveredMirrorXCell(null);
        state.setCurrentHoveredMirrorYCell(null);
        (0, animationManager_ts_1.startAnimation)();
        return;
    }
    var snappedCellTopLeftX_Absolute = state.logicalGridCells.offsetX +
        Math.floor((effectiveClickX - state.logicalGridCells.offsetX) /
            flowerGridSnapCellPixelSize) *
            flowerGridSnapCellPixelSize;
    var snappedCellTopLeftY_Absolute = state.logicalGridCells.offsetY +
        Math.floor((effectiveClickY - state.logicalGridCells.offsetY) /
            flowerGridSnapCellPixelSize) *
            flowerGridSnapCellPixelSize;
    var updateHoverCellValidation = function (targetX, targetY) {
        if (targetX >= state.logicalGridCells.offsetX &&
            targetX + flowerGridSnapCellPixelSize <=
                state.logicalGridCells.offsetX + state.logicalGridCells.totalWidthPx &&
            targetY >= state.logicalGridCells.offsetY &&
            targetY + flowerGridSnapCellPixelSize <=
                state.logicalGridCells.offsetY + state.logicalGridCells.totalHeightPx) {
            return { x: targetX, y: targetY };
        }
        return null;
    };
    var rawMirrored = (0, mirroringUtils_ts_1.calculateRawMirroredCellCoordinates)(snappedCellTopLeftX_Absolute, snappedCellTopLeftY_Absolute, flowerGridSnapCellPixelSize, state.logicalGridCells);
    state.setCurrentHoveredPrimaryCell(updateHoverCellValidation(rawMirrored.primary.x, rawMirrored.primary.y));
    state.setCurrentHoveredMirrorXCell(rawMirrored.mirrorX
        ? updateHoverCellValidation(rawMirrored.mirrorX.x, rawMirrored.mirrorX.y)
        : null);
    state.setCurrentHoveredMirrorYCell(rawMirrored.mirrorY
        ? updateHoverCellValidation(rawMirrored.mirrorY.x, rawMirrored.mirrorY.y)
        : null);
    state.setCurrentHoveredMirroredCell(rawMirrored.mirrorXY
        ? updateHoverCellValidation(rawMirrored.mirrorXY.x, rawMirrored.mirrorXY.y)
        : null);
    var createThisMove = false;
    var forceFlowerCreation = false;
    if (state.currentHoveredPrimaryCell &&
        config.numberOfMockUsers > 0 &&
        performance.now() >= state.initialCursorVisibilityDelayEndTime) {
        for (var _i = 0, _a = state.mockUserCursors; _i < _a.length; _i++) {
            var mockCursor = _a[_i];
            if (!mockCursor.isMoving &&
                mockCursor.currentPixelX > -500 &&
                mockCursor.currentPixelX === state.currentHoveredPrimaryCell.x &&
                mockCursor.currentPixelY === state.currentHoveredPrimaryCell.y) {
                createThisMove = true;
                forceFlowerCreation = true;
                break;
            }
        }
    }
    if (!createThisMove) {
        if (Math.random() < config.MOUSE_MOVE_FLOWER_SAMPLE_RATE) {
            createThisMove = true;
        }
    }
    if (createThisMove) {
        var specialColorOverridesForSet = undefined;
        if (state.enableSymmetricalSpecialColor &&
            state.currentHoveredPrimaryCell) {
            specialColorOverridesForSet = [];
            var basePatternDimension = Math.round(
            // Use proximity-adjusted dimension for base pattern
            config.MIN_PATTERN_DIMENSION_PROXIMITY +
                (config.PATTERN_DIMENSION +
                    config.MAX_PATTERN_DIMENSION_PROXIMITY_BOOST -
                    config.MIN_PATTERN_DIMENSION_PROXIMITY) *
                    state.mainCursorProximityFactor);
            var baseFillRatio = config.MIN_FILL_RATIO_PROXIMITY + // Use proximity-adjusted fill for base pattern
                (config.MAX_FILLED_CELL_RATIO +
                    config.MAX_FILL_RATIO_PROXIMITY_BOOST -
                    config.MIN_FILL_RATIO_PROXIMITY) *
                    state.mainCursorProximityFactor;
            var basePatternForSymmetry = (0, drawingUtils_ts_1.generatePatternData)(Math.max(config.MIN_PATTERN_DIMENSION_PROXIMITY, Math.min(config.PATTERN_DIMENSION +
                config.MAX_PATTERN_DIMENSION_PROXIMITY_BOOST, basePatternDimension)), Math.max(config.MIN_FILL_RATIO_PROXIMITY, Math.min(config.MAX_FILLED_CELL_RATIO +
                config.MAX_FILL_RATIO_PROXIMITY_BOOST, baseFillRatio)), "pixelStandard", state.mainCursorProximityFactor, state.currentColorPalette // Base palette for hover symmetry decision
            );
            if (basePatternForSymmetry) {
                for (var r = 0; r < basePatternForSymmetry.length; r++) {
                    for (var c = 0; c < basePatternForSymmetry[r].length; c++) {
                        if (basePatternForSymmetry[r][c].visible) {
                            var chosenColor = (0, colorUtils_ts_1.determineSpecialColorForSegment)(state.currentColorPalette, // Hover flowers use current palette for special color check
                            false, // Not a click
                            false, // Not a mock flower (main cursor hover)
                            forceFlowerCreation // hasEffectivePalette for overlap
                            );
                            if (chosenColor) {
                                specialColorOverridesForSet.push({ r: r, c: c, color: chosenColor });
                            }
                        }
                    }
                }
            }
        }
        createAndAddFlowerIfInteractive(state.currentHoveredPrimaryCell, "orig", false, state.mainCursorProximityFactor, forceFlowerCreation, false, specialColorOverridesForSet);
        createAndAddFlowerIfInteractive(state.currentHoveredMirrorXCell, "mirX", false, state.mainCursorProximityFactor, forceFlowerCreation, false, specialColorOverridesForSet);
        createAndAddFlowerIfInteractive(state.currentHoveredMirrorYCell, "mirY", false, state.mainCursorProximityFactor, forceFlowerCreation, false, specialColorOverridesForSet);
        createAndAddFlowerIfInteractive(state.currentHoveredMirroredCell, "mirXY", false, state.mainCursorProximityFactor, forceFlowerCreation, false, specialColorOverridesForSet);
    }
    (0, animationManager_ts_1.startAnimation)();
}
exports.handleCanvasMouseMove = handleCanvasMouseMove;
function handleCanvasClick(event) {
    if (!dom.ctx || !dom.canvas || !state.logicalGridCells)
        return;
    var rect = dom.canvas.getBoundingClientRect();
    var clickCanvasX = (event.clientX - rect.left) * (dom.canvas.width / rect.width);
    var clickCanvasY = (event.clientY - rect.top) * (dom.canvas.height / rect.height);
    var effectiveClickX = clickCanvasX;
    var effectiveClickY = clickCanvasY;
    var flowerGridSnapCellPixelSize = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS * state.calculatedSegmentSize;
    if (flowerGridSnapCellPixelSize <= 0 ||
        state.logicalGridCells.numCols === 0 ||
        state.logicalGridCells.numRows === 0) {
        (0, animationManager_ts_1.startAnimation)();
        return;
    }
    var snappedCellTopLeftX_Absolute = state.logicalGridCells.offsetX +
        Math.floor((effectiveClickX - state.logicalGridCells.offsetX) /
            flowerGridSnapCellPixelSize) *
            flowerGridSnapCellPixelSize;
    var snappedCellTopLeftY_Absolute = state.logicalGridCells.offsetY +
        Math.floor((effectiveClickY - state.logicalGridCells.offsetY) /
            flowerGridSnapCellPixelSize) *
            flowerGridSnapCellPixelSize;
    var validateClickedCell = function (targetX, targetY) {
        if (targetX >= state.logicalGridCells.offsetX &&
            targetX + flowerGridSnapCellPixelSize <=
                state.logicalGridCells.offsetX + state.logicalGridCells.totalWidthPx &&
            targetY >= state.logicalGridCells.offsetY &&
            targetY + flowerGridSnapCellPixelSize <=
                state.logicalGridCells.offsetY + state.logicalGridCells.totalHeightPx) {
            return { x: targetX, y: targetY };
        }
        return null;
    };
    var rawMirroredCells = (0, mirroringUtils_ts_1.calculateRawMirroredCellCoordinates)(snappedCellTopLeftX_Absolute, snappedCellTopLeftY_Absolute, flowerGridSnapCellPixelSize, state.logicalGridCells);
    var proximityForClickColor = state.mainCursorProximityFactor; // Keep for color variety within CLICK_CURSOR_COLORS
    var specialColorOverridesForSet = undefined;
    if (state.enableSymmetricalSpecialColor) {
        specialColorOverridesForSet = [];
        // For click, use the CLICK_MAX_FILLED_CELL_RATIO and fixed PATTERN_DIMENSION for base pattern
        var basePatternForSymmetry = (0, drawingUtils_ts_1.generatePatternData)(config.PATTERN_DIMENSION, config.CLICK_MAX_FILLED_CELL_RATIO, "pixelStandard", undefined, // Proximity doesn't affect click structure for symmetry base
        config.CLICK_CURSOR_COLORS // Base palette for click symmetry decision
        );
        if (basePatternForSymmetry) {
            for (var r = 0; r < basePatternForSymmetry.length; r++) {
                for (var c = 0; c < basePatternForSymmetry[r].length; c++) {
                    if (basePatternForSymmetry[r][c].visible) {
                        var chosenColor = (0, colorUtils_ts_1.determineSpecialColorForSegment)(config.CLICK_CURSOR_COLORS, // Click flowers use CLICK_CURSOR_COLORS
                        true, // Is a click
                        false, // Not a mock flower
                        true // Has an effective palette (CLICK_CURSOR_COLORS)
                        );
                        if (chosenColor) {
                            specialColorOverridesForSet.push({ r: r, c: c, color: chosenColor });
                        }
                    }
                }
            }
        }
    }
    var primaryCellToClick = validateClickedCell(rawMirroredCells.primary.x, rawMirroredCells.primary.y);
    if (primaryCellToClick) {
        createAndAddFlowerIfInteractive(primaryCellToClick, "click-orig", false, proximityForClickColor, false, true, specialColorOverridesForSet);
    }
    var mirrorXCellToClick = rawMirroredCells.mirrorX
        ? validateClickedCell(rawMirroredCells.mirrorX.x, rawMirroredCells.mirrorX.y)
        : null;
    if (mirrorXCellToClick) {
        createAndAddFlowerIfInteractive(mirrorXCellToClick, "click-mirX", false, proximityForClickColor, false, true, specialColorOverridesForSet);
    }
    var mirrorYCellToClick = rawMirroredCells.mirrorY
        ? validateClickedCell(rawMirroredCells.mirrorY.x, rawMirroredCells.mirrorY.y)
        : null;
    if (mirrorYCellToClick) {
        createAndAddFlowerIfInteractive(mirrorYCellToClick, "click-mirY", false, proximityForClickColor, false, true, specialColorOverridesForSet);
    }
    var mirrorXYCellToClick = rawMirroredCells.mirrorXY
        ? validateClickedCell(rawMirroredCells.mirrorXY.x, rawMirroredCells.mirrorXY.y)
        : null;
    if (mirrorXYCellToClick) {
        createAndAddFlowerIfInteractive(mirrorXYCellToClick, "click-mirXY", false, proximityForClickColor, false, true, specialColorOverridesForSet);
    }
    (0, animationManager_ts_1.startAnimation)();
}
exports.handleCanvasClick = handleCanvasClick;
function handleCanvasMouseLeave() {
    state.setCurrentHoveredPrimaryCell(null);
    state.setCurrentHoveredMirroredCell(null);
    state.setCurrentHoveredMirrorXCell(null);
    state.setCurrentHoveredMirrorYCell(null);
    state.setMainCursorProximityFactor(0.0); // Reset proximity factor when mouse leaves
    (0, animationManager_ts_1.startAnimation)();
}
exports.handleCanvasMouseLeave = handleCanvasMouseLeave;
